// src/components/OCRComponent.js
import { useEffect, useState, useRef } from 'react';

const OCRComponent = ({ image, onExtracted, onStart, rotationAngle = 0 }) => {
  const [hasExtracted, setHasExtracted] = useState(false);
  const processingRef = useRef(false);

  useEffect(() => {
    if (image && !hasExtracted && !processingRef.current) {
      processingRef.current = true;
      if (onStart) onStart(); // Notifica l'inizio dell'OCR
      
      // Prepara un'immagine già ruotata se necessario
      const processImage = async () => {
        let imageToProcess = image;
        
        // Se c'è una rotazione, ruotiamo prima l'immagine
        if (rotationAngle !== 0) {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          const img = new Image();
          
          await new Promise((resolve) => {
            img.onload = () => {
              // Determina se dobbiamo scambiare larghezza e altezza (per rotazioni di 90° e 270°)
              const isPortrait = (Math.abs(rotationAngle) === 90 || Math.abs(rotationAngle) === 270);
              
              canvas.width = isPortrait ? img.height : img.width;
              canvas.height = isPortrait ? img.width : img.height;
              
              // Trasla e ruota il contesto
              ctx.translate(canvas.width / 2, canvas.height / 2);
              ctx.rotate((rotationAngle * Math.PI) / 180);
              ctx.drawImage(img, -img.width / 2, -img.height / 2);
              
              imageToProcess = canvas.toDataURL('image/jpeg');
              resolve();
            };
            img.src = image;
          });
        }
        
        // Caricamento lazy di Tesseract (non nel bundle iniziale)
        const { default: Tesseract } = await import('tesseract.js');

        // Esegui OCR sull'immagine (eventualmente ruotata)
        return Tesseract.recognize(imageToProcess, 'ita', {
          logger: (m) => console.log(m),
        });
      };
      
      processImage()
        .then(({ data: { text } }) => {
          onExtracted(text);
          setHasExtracted(true); // Blocca ulteriori esecuzioni per la stessa immagine
          processingRef.current = false;
        })
        .catch((error) => {
          console.error('Errore OCR:', error);
          onExtracted("Errore nell'estrazione del testo.");
          setHasExtracted(true);
          processingRef.current = false;
        });
    }
  }, [image, onExtracted, onStart, hasExtracted, rotationAngle]);

  // Reset dello stato quando cambia l'immagine
  useEffect(() => {
    setHasExtracted(false);
  }, [image]);

  return null;
};

export default OCRComponent;